require('bootstrap-select');
var init = function init() {
  return $('.selectpicker').selectpicker('render');
};

// Quickly initialize bootstrap-select objects
try {
  init();
} catch (log) {
  var _window$console, _window$console$log;
  // Log init failures
  (_window$console = window.console) === null || _window$console === void 0 || (_window$console$log = _window$console.log) === null || _window$console$log === void 0 ? void 0 : _window$console$log.call(_window$console, log);
  try {
    // Allow main thread to complete and retry
    setTimeout(init, 0);
  } catch (error) {
    var _window$console2, _window$console2$erro;
    (_window$console2 = window.console) === null || _window$console2 === void 0 || (_window$console2$erro = _window$console2.error) === null || _window$console2$erro === void 0 ? void 0 : _window$console2$erro.call(_window$console2, error);
  }
}
module.exports = {
  methods: {
    init: init
  },
  updateValidity: function updateValidity() {
    $('.selectpicker').on('changed.bs.select', function () {
      if (this.checkValidity()) {
        $(this).removeClass('is-invalid');
      }
    });
  }
};